export default "__VITE_ASSET__C$WJ0tXI__"